import React from 'react';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import Features from '../components/Features';
import Footer from '../components/Footer';
import Header from '../components/Header';
import SEO from '../components/SEO';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://lsabill.net/#organization',
      name: 'LSABill',
      url: 'https://lsabill.net/',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer support',
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://lsabill.net/#website',
      url: 'https://lsabill.net/',
      name: 'LSABill',
      publisher: {
        '@id': 'https://lsabill.net/#organization',
      },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://lsabill.net/#webpage',
      url: 'https://lsabill.net/',
      name: 'LSABill',
      description:
        'Manage subscriptions, request cancellations, review billing charges, and contact support agents for fast assistance and account help.',
      isPartOf: {
        '@id': 'https://lsabill.net/#website',
      },
      about: {
        '@id': 'https://lsabill.net/#subscription-support-service',
      },
    },
    {
      '@type': 'Service',
      '@id': 'https://lsabill.net/#subscription-support-service',
      name: 'LSABill Subscription Support Service',
      description:
        'Online service for managing subscriptions, requesting cancellations, reviewing billing charges, and contacting support agents.',
      url: 'https://lsabill.net/',
      provider: {
        '@id': 'https://lsabill.net/#organization',
      },
    },
  ],
};

export default function HomePage() {
  return (
    <div className="page-shell min-h-screen">
      <SEO
        title="Subscription Support & Cancellation Help | Learnaicare"
        description="Manage subscriptions, request cancellations, review billing charges, and contact support agents for fast assistance and account help."
        canonical="https://lsabill.net/"
        ogUrl="https://lsabill.net/"
        schema={homeSchema}
      />
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Features />
      </main>
      <Footer />
    </div>
  );
}
